import cn from 'classnames'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import { createUseStyles } from '../../helpers/createStyles'
import { theme } from '../../styles/theme'
import Section from '../Section'
import ImageBlock, { imageBlockProps } from '../ImageBlock'

import useScrollTrigger from '../../hooks/useScrollTrigger'

const isSinglePortrait = ({ images }) => {
  const ar = get(images, '0.asset.metadata.dimensions.aspectRatio', 1)
  return images.length === 1 && ar < 1
}

const JournalImages = ({ data: { imageBlock, fullWidth }, page }) => {
  const styles = useStyles()

  const isJournal = page?.parent?.slug === 'journal' || page?.slug === 'rug-placement-guide'

  const sectionRef = useScrollTrigger(
    () => ({
      trigger: sectionRef.current,
      start: () => `${window.innerHeight / 4}px bottom`,
      scrub: false
    }),
    (tl, ref) => {
      const defaults = {
        ease: 'power2.inOut',
        duration: 0.8
      }
      tl.from(ref.current.querySelectorAll('.image-block-wrapper > *'), { opacity: 0, stagger: 0.1, ...defaults })
    }
  )

  return (
    <Section
      grid={!fullWidth}
      fullWidth={fullWidth}
      noBottomMargin
      className={styles.root}
      ref={sectionRef}
    >
      {imageBlock &&
        <ImageBlock
          className={cn(styles.block, isJournal && styles.journalBlock, {
            [styles.portrait]: isSinglePortrait(imageBlock)
          })}
          block={imageBlock}
          hideCaptions={fullWidth}
        />}
    </Section>
  )
}

const useStyles = createUseStyles({
  root: {
    marginBottom: theme.spacingPx(4),
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacingPx(10)
    }
  },
  fullWidthRoot: {
    marginLeft: '0!important',
    marginRight: '0!important'
  },
  block: {
    gridColumn: '1 / -1',
    [theme.breakpoints.up('md')]: {
      gridColumnStart: 5,
      '.dialog-grid &': {
        gridColumnStart: 5
      }
    }
  },
  journalBlock: {
    [theme.breakpoints.up('md')]: {
      '.dialog-grid &': {
        gridColumnStart: 4
      }
    }
  },
  portrait: {
    [theme.breakpoints.up('md')]: {
      gridColumnEnd: 'span 6'
    }
  }
})

JournalImages.propTypes = {
  data: PropTypes.shape({
    fullWidth: PropTypes.bool,
    imageBlock: PropTypes.shape(imageBlockProps)
  }).isRequired
}

export default JournalImages
